import React, { useState } from "react";
import { Phone, X } from "lucide-react";
import { businessInfo } from "../mock";

const stripPhone = (p) => p.replace(/[^0-9]/g, "");

const ViberIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M12.1 1C9.9 1 6.4 1.3 4.4 3.1 2.9 4.5 2.3 6.6 2.3 9.2c0 2.5-.1 7.2 4.4 8.5v2.5s0 .6.4.7c.5.1.8-.3 1.3-.8.3-.3.7-.7 1-1.1 3.1.3 5.5-.3 5.8-.4.6-.2 4.1-.6 4.7-5.3.6-4.8-.3-7.8-1.9-9.2-.5-.4-2.5-1.9-7-1.9h-.9zm.3 1.7c3.8 0 5.4 1.2 5.8 1.6 1.3 1.1 2 3.7 1.5 7.7-.5 3.9-3.3 4.2-3.8 4.4-.2.1-2.3.6-5 .4 0 0-2 2.4-2.6 3-.1.1-.2.1-.3.1-.1 0-.1-.2-.1-.3v-3.1C4.2 15.4 4 11.6 4 9.5s.4-3.7 1.6-4.9c1.7-1.5 4.9-1.9 6.8-1.9zm.1 2.3c-.2 0-.3.2-.3.4s.2.3.4.3c1.7.1 3.1.6 4.1 1.8.9 1 1.3 2.4 1.3 4 0 .2.2.4.4.4s.4-.2.4-.4c0-1.8-.5-3.4-1.6-4.6-1.2-1.3-2.8-1.9-4.7-1.9zm.2 1.6c-.2 0-.4.1-.4.3s.1.4.3.4c1.1.1 1.9.4 2.5 1 .6.6.9 1.4.9 2.4 0 .2.2.4.4.4s.4-.2.4-.4c0-1.2-.4-2.2-1.1-3-.8-.8-1.8-1.2-3-1.1zm.2 1.6c-.2 0-.4.1-.4.3s.1.4.3.4c.9.1 1.4.5 1.5 1.5 0 .2.2.3.4.3s.3-.2.3-.4c-.1-1.3-.9-2-2.1-2.1zM9 6.3c-.2 0-.4 0-.6.1-.4.2-.9.7-1.1 1.1-.2.4-.3.8-.2 1.3.2 1.3 1 2.8 2.2 4.3 1.2 1.5 2.6 2.6 4 3.2.5.2 1 .3 1.5.1.5-.1 1-.6 1.3-1 .2-.3.2-.7 0-1-.4-.5-1.3-1.1-1.8-1.4-.3-.2-.7-.1-.9.1l-.5.5c-.2.2-.5.2-.7.1-.6-.3-1.3-.9-1.8-1.5-.5-.6-1-1.3-1.2-2-.1-.2 0-.5.2-.7l.5-.4c.3-.2.4-.6.2-.9-.2-.5-.7-1.5-1.1-1.9-.1-.1-.3-.2-.5-.2z" />
  </svg>
);

const ViberLink = ({ label, phone }) => (
  <a
    href={`viber://chat?number=%2B30${stripPhone(phone)}`}
    data-testid={`viber-link-${stripPhone(phone)}`}
    className="flex items-center gap-3 rounded-md border border-purple-400/40 bg-purple-500/10 hover:bg-purple-500/20 transition-colors px-3 py-2.5"
  >
    <div className="w-9 h-9 rounded-full bg-[#7360F2] flex items-center justify-center shrink-0">
      <ViberIcon className="w-5 h-5 text-white" />
    </div>
    <div className="text-left">
      <div className="text-xs text-purple-200/80">{label}</div>
      <div className="text-sm text-white font-medium">{phone}</div>
    </div>
  </a>
);

const ViberButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-col items-end gap-3">
      {open && (
        <div
          data-testid="viber-popup"
          className="pcb-card p-4 w-72 shadow-2xl animate-in fade-in slide-in-from-bottom-2 duration-200"
        >
          <div className="flex items-start justify-between gap-3">
            <div>
              <div className="text-white font-semibold">Viber</div>
              <div className="text-xs text-purple-200/60 mt-0.5">
                Στείλτε μας μήνυμα ή καλέστε
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="text-purple-200/70 hover:text-white p-1"
              aria-label="close"
              data-testid="viber-close-btn"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          <div className="mt-4 space-y-2">
            <ViberLink label="Viber 1" phone={businessInfo.mobile} />
            <ViberLink label="Viber 2" phone={businessInfo.mobile2} />
          </div>
          <a
            href={`tel:+30${stripPhone(businessInfo.mobile)}`}
            data-testid="viber-call-link"
            className="mt-3 flex items-center justify-center gap-2 text-xs text-purple-200/70 hover:text-white transition-colors"
          >
            <Phone className="w-3.5 h-3.5" /> Ή απλή κλήση
          </a>
        </div>
      )}

      <button
        onClick={() => setOpen((s) => !s)}
        aria-label="Viber"
        data-testid="viber-float-btn"
        className="relative w-14 h-14 rounded-full bg-[#7360F2] hover:bg-[#5f4de0] transition-colors flex items-center justify-center shadow-lg shadow-purple-900/40"
      >
        <ViberIcon className="w-7 h-7 text-white" />
        {!open && (
          <span className="absolute inset-0 rounded-full bg-[#7360F2] animate-ping opacity-30" />
        )}
      </button>
    </div>
  );
};

export default ViberButton;
